import { PageHero, SectionHeading, CTABand, ServiceCard } from "../components/shared";
import { SERVICES, IMAGES } from "../data/content";

const Services = () => (
  <>
    <PageHero overline="Our Services" title="Capabilities Across the Infrastructure Lifecycle" subtitle="Eight delivery capabilities — engaged as individual work packages or coordinated end-to-end programmes." image={IMAGES.engineer} />
    <section className="py-24 bg-white">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8">
        <SectionHeading overline="What We Do" title="Service Portfolio" />
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {SERVICES.map((s, i) => <ServiceCard key={s.slug} s={s} index={i} />)}
        </div>
      </div>
    </section>
    <CTABand />
  </>
);

export default Services;
